import { render, staticRenderFns } from "./dashboardOrcamentoFonteRecursos.vue?vue&type=template&id=b62c801a&"
import script from "./dashboardOrcamentoFonteRecursos.vue?vue&type=script&lang=js&"
export * from "./dashboardOrcamentoFonteRecursos.vue?vue&type=script&lang=js&"
import style0 from "./dashboardOrcamentoFonteRecursos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports